import React from 'react';

import SearchFieldCollapse from '../components/SearchFieldCollapse';

import HomeScreen from '../components/HomeScreen';

const Home = () => {
  return (
    <div>
      <SearchFieldCollapse />
      <HomeScreen />
    </div>
  );
};

export default Home;
